/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";

export const getAllEquipments = () => {
  return progressApi.get("/TagMeta/GetAllEquipments");
};

export const getEquipmentsByUnitId = (unitId = 0) => {
  return progressApi.get(`/TagMeta/GetEquipmentsByUnitId?id=${unitId}`);
};

export const createEquipment = (equipment: any) => {
  return progressApi.post("/TagMeta/CreateEquipment", equipment);
};

export const updateEquipment = (equipment: any) => {
  return progressApi.post("/TagMeta/UpdateEquipment", equipment);
};

export const deleteEquipment = (id: any) => {
  return progressApi.get(`/TagMeta/DeleteEquipment?id=${id}`);
};
